import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=1a8c3d9e&scoped=true"
import script from "./RelationList.vue?vue&type=script&lang=js"
export * from "./RelationList.vue?vue&type=script&lang=js"
import style0 from "./RelationList.vue?vue&type=style&index=0&id=1a8c3d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c3d9e",
  null
  
)

export default component.exports